import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCard, MatCardHeader, MatCardContent } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect, MatOption } from '@angular/material/select';
import { LocationSilo, OrderingInformation } from '@next/core-lib/cart';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { BreakpointService, BreakpointServiceInjector } from '@next/core-lib/responsive';
import { Store } from '@ngrx/store';
import { Observable, skipWhile } from 'rxjs';

import { FormatSiloTitlePipe } from '../../pipes/format-silo-title.pipe';
import * as ProductSelectors from '../../store/selectors';

@Component({
  selector: 'app-productlist-silo',
  templateUrl: './productlist-silo.component.html',
  styleUrls: ['./productlist-silo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    MatCard,
    MatCardHeader,
    MatCardContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    NgFor,
    MatOption,
    MatProgressSpinner,
    MatIcon,
    AsyncPipe,
    AgrI18nSharedModule,
    FormatSiloTitlePipe,
  ],
})
export class ProductlistSiloComponent {
  @Input() orderingInformation: OrderingInformation | undefined;
  @Input() selectedSiloId: number | undefined;
  @Input() quantity: number | undefined;

  @Output() silosChange = new EventEmitter<number[]>();

  selectedSilos: LocationSilo[] = [];

  group: FormGroup = new FormGroup({
    full: new FormControl(),
  });

  locationSilos$: Observable<LocationSilo[]> = this.store.select(ProductSelectors.selectSilos);
  silosLoaded$: Observable<boolean> = this.store.select(ProductSelectors.selectSilosLoaded);
  silosNotAvailable$: Observable<boolean> = this.store.select(ProductSelectors.selectSilosNotAvailable);

  isLtSm$ = this.breakpointService.ltSm$;
  quantity$: Observable<number>;

  constructor(
    private readonly store: Store,
    @Inject(EnvironmentInjector) readonly env: AgrEnvironment,
    @Inject(BreakpointServiceInjector) private readonly breakpointService: BreakpointService,
  ) {
    this.locationSilos$.pipe(skipWhile(() => this.selectedSiloId === undefined)).subscribe((locationSilos) => {
      this.selectedSilos = [locationSilos.find((s) => s.id === this.selectedSiloId)];
    });

    this.group.controls.full.valueChanges.subscribe((fullSilos) => {
      const selectedSiloIds = fullSilos ? fullSilos.map((s) => s.id) : [];
      this.silosChange.emit(selectedSiloIds);
    });
  }
}
